




























import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Package } from "../models/package";
import { PackageGroup } from "../models/packagegroup";

@Component
export default class ProductIcon extends Vue {
  @Prop() public pkg?: Package;
  @Prop() public group?: PackageGroup;
  @Prop() public title?: string;

  @Prop({ default: 50 }) public Size?: number;

  get _title(): string {
    const item: any = this.pkg || this.group;
    return this.title || item.title || (item.item ? item.item.title : "");
  }
  get productType() {
    const title = this._title;
    if (!title) {
      return "";
    }
    if (title.search(/hearscope/i) > -1) {
      return "scope";
    }
    if (title.search(/hearkiosk/i) > -1) {
      return "kiosk";
    }
    if (title.search(/peek/i) > -1) {
      return "peek";
    }
    if (title.search(/hearscreen/i) > -1) {
      return "screen";
    }
    if (title.search(/heartest/i) > -1) {
      return "test";
    }
    if (title.search(/heardigits/i) > -1) {
      return "digits";
    }
    if (title.search(/hardware/i) > -1) {
      return "hardware";
    }
    if (title.search(/sealCheck/i) > -1) {
      return "sealCheck";
    }
    if (title.search(/calibration/i) > -1) {
      return "calibration";
    }
    if (title.search(/shipping/i) > -1) {
      return "shipping";
    }
    if (title.search(/vision/i) > -1) {
      return "vision";
    }
    if (title.search(/selftest/i) > -1) {
      return "selftest";
    }
    return "custom";
  }

  get stl() {
    return { width: `${this.Size}px`, height: `${this.Size}px` };
  }

  get stlSvg() {
    const xy = this.Size || 50;
    return {
      width: `${(xy / 100) * 90}px`,
      height: `${(xy / 100) * 90}px`,
      paddingLeft: `${(xy / 100) * 10}px`,
      paddingTop: `${(xy / 100) * 8}px`,
      paddingBottom: `${(xy / 100) * 10}px`,
    };
  }
}
